


















































import AbpBase from "../../../../lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import {
	DeletePatPropagandaPlan,
	GetPatPropagandaPlan,
	GetPatPropagandaPlanHist,
	SavePatPropagandaPlan
} from "@/api/propaganda"
import Edu from './edu.vue'
import Evaluate from './evaluate.vue'
import {GetUsers} from "@/api/dialysisProcess"

@Component({
	components: {Edu, Evaluate}
})
export default class EducationPlan extends AbpBase {
	@Prop({type: Boolean, default: false}) value: Boolean
	@Prop() data: any
	medicalStaff: any = []
	/*
	* mode 三种状态
	*   1.show 展示患者没有评价过的宣教
	*   2.edit 编辑状态
	*   3.history 已评价过过的宣教历史
	*
	* */
	mode = 'show'
	private objects: Array<any> = []
	// 已选过的宣教  将不会在添加选中展示
	private selectIds: Array<any> = []
	eduShow = false
	spinShow = false

	created() {
		this.mode = this.data.mode || 'show'
		this.getSelects()
		this.getData()
	}

	async save() {
		this.objects.forEach((item: any, index: number) => {
			item.orderBy = index
			item.planDate = this.formatDate(item.planDate)
		})
		let res = await SavePatPropagandaPlan(this.objects)
		this.getData()
		this.mode = 'show'
	}
	evaluateSaveSuccess(){
		this.getData()
		this.evaluateShow = false
	}
	deleteOne(item: any) {
		this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeletePatPropagandaPlan({Id: item.id})
			this.getData()
		}).catch(() => {

		});
	}
	evaluateData:any = {}
	evaluateShow = false
	evaluate(item: any) {
		this.evaluateData = item
		this.evaluateShow = true
	}
	get title(){
		return this.mode === 'history' ? '宣教历史' : '详情'
	}
	add() {
		this.selectIds = this.objects.map((item) => {
			return item.resourceId
		})
		this.eduShow = true
	}

	saveSuccess(arr: Array<any>) {
		arr.forEach((item: any, index: number) => {
			this.objects.push({
				patientId: this.data.data.row.patientId,
				planDate: new Date(),
				docId: '',
				resourceId: item.id,
				orderBy: index,
				status: true,
				resourceTitle: item.resourceTitle,
				corerImagePath: item.corerImagePath
			})
		})
		this.eduShow = false
	}

	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
		}
	}

	private async getData() {
		this.spinShow = true
		let query = {patientId: this.data.data.row.patientId}
		let res
		if (this.mode !== 'history') {
			res = await GetPatPropagandaPlan(query)
		} else {
			res = await GetPatPropagandaPlanHist(query)
		}
		this.objects = res.objects
		this.spinShow = false
	}
	private async getSelects() {
		let res = await GetUsers({})
		this.medicalStaff = res.objects.filter((item:any) => {
			return item.userName !== 'admin'
		})
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/education/educationPlan/parts/detail.vue